import { useState } from "react";
import { useLogin, useNotify } from "react-admin";
import { TextField, Button, Typography, Box } from "@mui/material";
import useStyles from "./style";
import { usePageTitle } from "@/utilities";

const LoginPage = () => {
  const classes = useStyles();
  const login = useLogin();
  const notify = useNotify();

  const [credentials, setCredentials] = useState({
    username: "",
    password: "",
  });

  const [loading, setLoading] = useState(false);

  usePageTitle("Connexion");

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();

    try {
      setLoading(true);
      await login(credentials, "/");
    } catch {
      notify("Invalid username or password", { type: "warning" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={classes.root}>
      <div className={classes.form}>
        <Box
          className={classes.logo}
          component="img"
          src="/logo-gameoo.png"
          alt="GAMEOO"
        />

        <Typography className={classes.title} variant="h5" align="left">
          Connexion à GAMEOO
        </Typography>

        <form onSubmit={handleSubmit}>
          <TextField
            className={classes.input}
            label="Pseudo"
            variant="outlined"
            fullWidth
            autoComplete="username"
            value={credentials.username}
            onChange={(e) =>
              setCredentials({
                ...credentials,
                username: e.target.value,
              })
            }
            sx={{ marginBottom: "16px" }}
          />

          <TextField
            className={classes.input}
            label="Mot de passe"
            type="password"
            variant="outlined"
            fullWidth
            autoComplete="current-password"
            value={credentials.password}
            onChange={(e) =>
              setCredentials({
                ...credentials,
                password: e.target.value,
              })
            }
            sx={{ marginBottom: "16px" }}
          />

          <Button
            className={classes.button}
            type="submit"
            variant="contained"
            disabled={loading}
          >
            {loading ? "Connexion..." : "Se connecter"}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
